(function($, once) {

  Drupal.behaviors.block_header = {
    attach(context) {
      once('block-header--processed', '[data-component-id="nuplayer:block_header"]', context).forEach((headerJQ) => {
        // If the subheading is longer than one line, add a class to the header so we can
        // style it differently.
        const header = $(headerJQ)[0];
        const subheading = header.querySelector('.sub-heading');
        const subheadingHeight = subheading ? subheading.offsetHeight : 0;
        const subheadingLineHeight = subheading ? parseFloat(getComputedStyle(subheading).lineHeight) + 1 : 0;
        if (subheadingHeight > subheadingLineHeight) {
          $(header)[0].classList.add("long-text");
        }
      });
    }
  };
})(jQuery, once);
